export const GRAY_COLOR = '#C6C6C6';
export const BLACK_COLOR = '#000000';
export const ALEA_COLOR = '#2B4956';
